import { Marker, useNavermaps } from 'react-naver-maps';

type NaverMapUserMarkerProps = {
	latitude?: number;
	longitude?: number;
};

const NaverMapUserMarker = ({
	latitude,
	longitude,
}: NaverMapUserMarkerProps) => {
	const navermaps = useNavermaps();

	if (!latitude || !longitude) {
		return null;
	}

	return (
		<Marker
			position={new navermaps.LatLng(latitude, longitude)}
			icon={{
				content: `<div style="position:relative;width:56px;height:56px;">
										<div style="width:56px;height:56px;border-radius:50%;background:rgba(255,195,66,0.3);"></div>
										<div style="position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:16px;height:16px;border-radius:50%;background:#FFC342;"></div>
									</div>`,
				anchor: new navermaps.Point(28, 28),
			}}
			clickable={false}
		/>
	);
};

export default NaverMapUserMarker;
